<template>
  <div class="flex flex-col gap-4">
    <emd-alert
      v-if="isReallocated"
      noClose
      class="eu-mt_5"
      variant="warning"
      :title="$t('alert.title')"
    >
      <template #content>
        {{ $t('alert.content') }}
        <a href="#">
          {{ $t('alert.link') }}
        </a>
      </template>
    </emd-alert>
    <jade-box :title="$t('servideOrder')">
      <template>
        <div
          v-if="loadingList"
          class="eu-pa_6 eu-align_center"
          data-testid="show-loading"
        >
          <jade-spinner />
        </div>
        <div
          class="py-2"
          v-else
        >
          <Table
            :fields="fields"
            :items="[translatedPhysicalWorldOrder]"
          />
        </div>
      </template>
    </jade-box>
    <jade-box
      :title="$t('information')"
      hasPadding
    >
      <template>
        <div
          v-if="loadingList"
          class="eu-pa_6 eu-align_center"
          data-testid="show-loading"
        >
          <jade-spinner />
        </div>
        <form-shell
          v-else
          :formsOnShell="formsOnShell"
          class="eu-no-border"
          onlyFields
          removePadding
        />
      </template>
    </jade-box>

    <history-details
      :historyFields="historyFields"
      :loading="loadingList"
      title="service-order-history"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { EmdAlert } from 'emerald-vue/src/components'
import { JadeBox, JadeSpinner } from '@jade'

import Table from '@/components/project/molecules/Table.vue'
import FormShell from '@/views/PhysicalWorld/components/FormShell'

import { isReallocated } from '@/enums/physical-world.enum.js'

import HistoryDetails from '../components/HistoryDetails.vue'

import { SERVICE_ORDERS_FIELDS } from './service-order-table.fields'
import ServiceOrdersDetailsManager from './service-orders-details.manager'

export default {
  name: 'ServiceOrdersDetails',
  components: {
    FormShell,
    HistoryDetails,
    Table,
    EmdAlert,
    JadeBox,
    JadeSpinner
  },
  data () {
    return {
      fields: SERVICE_ORDERS_FIELDS.map(item => ({
        ...item,
        label: this.$t(item.label),
        transform: text => {
          if (!text) return
          return this.$t(text.toLowerCase())
        },
        type:
          typeof item.type === 'function' ? item.type(this.isLink) : item.type
      }))
    }
  },
  computed: {
    ...mapGetters(['physicalWorldOrder', 'loadingList']),
    formsOnShell () {
      return new ServiceOrdersDetailsManager(
        this.physicalWorldOrder
      ).getFields()
    },
    translatedPhysicalWorldOrder () {
      return {
        ...this.physicalWorldOrder,
        status: this.physicalWorldOrder.status_description?.toLowerCase(),
        type: this.physicalWorldOrder.type_description
      }
    },
    historyFields () {
      return new ServiceOrdersDetailsManager(
        this.physicalWorldOrder
      ).historyAdapter()
    },
    isReallocated () {
      return isReallocated(this.physicalWorldOrder?.status)
    }
  }
}
</script>

<i18n src="../physical-world-status.locale.json"></i18n>
<i18n src="./service-orders-filters.locale.json"></i18n>
<i18n>
  {
    "pt-BR": {
      "success": {
        "title": "Solicitação de maquininha",
        "info": "Maquininha solicitada com sucesso",
        "content": "Ao clicar no botão abaixo, você será encaminhado para listagem de ordens de serviço para acompanhar sua solicitação."
      },
      "alert":{
        "title": "Ordem de serviço realocada",
        "content": "Uma nova ordem de serviço foi criada para esta solicitação. Para acompanhar a nova ordem, retorne à lista de ordens de serviço. Em caso de dúvidas, ",
        "link": "acesse nossa central de ajuda."
      },
      "information": "Informações",
      "servideOrder": "Ordem de Serviço"
  },
    "en-US": {
      "success": {
          "title": "Request for Terminal",
          "info": "Terminal requested successfully",
          "content": "By clicking the button below, you will be redirected to the service order list to track your request."
      },
      "alert":{
        "title": "Service order relocated",
        "content": "A new work order has been created for this request. To track the new order, return to the work order list. If you have any questions, ",
        "link": "visit our help center."
      },
      "information": "Information",
      "servideOrder": "Service Order"
    }
  }
  </i18n>
